/**
 * WordPress dependencies
 */
import { createContext, useContext } from '@wordpress/element';

/**
 * Internal dependencies
 */

export const NavigationGroupContext = createContext({
  group: undefined
});
NavigationGroupContext.displayName = 'NavigationGroupContext';
export const useNavigationGroupContext = () => useContext(NavigationGroupContext);